import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CreateListingForm } from './components/CreateListingForm';
import { getMySellerAlias } from '../../features/marketplace/api';

export function MarketplaceCreatePage() {
  const navigate = useNavigate();
  const [sellerAlias, setSellerAlias] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSellerAlias();
  }, []);

  async function loadSellerAlias() {
    try {
      setLoading(true);
      // First try localStorage
      const savedAlias = localStorage.getItem('marketplace.sellerAlias');
      if (savedAlias) {
        setSellerAlias(savedAlias);
        setLoading(false);
        return;
      }

      // Then try API
      const response = await getMySellerAlias();
      if (response.registered && response.alias) {
        setSellerAlias(response.alias.sellerAlias);
        localStorage.setItem('marketplace.sellerAlias', response.alias.sellerAlias);
      } else {
        // No seller alias registered, redirect to seller dashboard
        navigate('/marketplace/seller');
      }
    } catch (err) {
      console.error('Failed to load seller alias:', err);
      navigate('/marketplace/seller');
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-white dark:bg-slate-900">
        <div className="text-center text-slate-600 dark:text-slate-400 py-12">Loading...</div>
      </div>
    );
  }

  if (!sellerAlias) {
    return (
      <div className="min-h-screen bg-white dark:bg-slate-900">
        <div className="max-w-2xl mx-auto px-4 py-12">
          <div className="bg-yellow-100 dark:bg-yellow-900/20 border border-yellow-300 dark:border-yellow-800 rounded-lg p-6 text-yellow-800 dark:text-yellow-400">
            <h2 className="text-lg font-semibold mb-2">Seller Alias Required</h2>
            <p>You need to register a seller alias before creating listings.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white dark:bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <CreateListingForm sellerAlias={sellerAlias} />
      </div>
    </div>
  );
}
